import { createContext, useContext, useEffect, useState } from 'react';
import eventBus from '@sas/nova-core/eventBus';
import { CONTENT_MUTATION_EVENT, isContentMutationEventData } from '../services/mutation';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentNavigationStateContext = /*#__PURE__*/createContext(undefined);
export const ContentNavigationStateDispatch = /*#__PURE__*/createContext(undefined);

/**
 * Returns the current navigation context for the nearest provider, or undefined if not under a
 * ContentNavigationProvider.
 */
export const useContentNavigationState = () => {
  return useContext(ContentNavigationStateContext);
};

/**
 * Dispatch a new navigation context to all components consuming this provider. Will return undefined
 * if not under a ContentNavigationProvider.
 */
export const useContentNavigationDispatch = () => {
  return useContext(ContentNavigationStateDispatch);
};
/**
 * Provide navigational behavior to components that consume this provider. This means all consumers
 * will display the same location (generally a folder), whether it's the contents of the folder, or
 * the folder itself, depending on the component. Components can consume and dispatch changes to
 * the current navigation using the hooks.
 * @param initialValue
 * @param children
 * @constructor
 */
export const ContentNavigationProvider = ({
  initialValue,
  children
}) => {
  const [state, setState] = useState(initialValue);
  useEffect(() => {
    function onMutate(_name, evt) {
      const data = evt?.data;
      if (data && isContentMutationEventData(data) && data.mutationType === 'delete' && data.items.find(item => state.location && data.dataProvider.doesItemMatchIdentifier(item, state.location))) {
        // reset the context when the location is deleted.
        setState(prev => {
          return {
            ...prev,
            location: undefined,
            locationContextPath: []
          };
        });
      }
    }
    eventBus.subscribe(CONTENT_MUTATION_EVENT, onMutate);
    return () => {
      eventBus.unsubscribe(CONTENT_MUTATION_EVENT, onMutate);
    };
  }, [state, setState]);
  return /*#__PURE__*/_jsx(ContentNavigationStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(ContentNavigationStateDispatch.Provider, {
      value: setState,
      children: children
    })
  });
};
//# sourceMappingURL=ContentNavigationProvider.js.map